import { makeShippingProtectionClaimLoader, redirect } from '~/utils/routing';

export const { loader, useLoaderData } = makeShippingProtectionClaimLoader(
  ({ context, params: { store = '' } }) =>
    context.order.shippingClaimReasonOverrides?.find(
      (override) => override.reason === context.shippingProtectionClaim.reason,
    ) ?? redirect(`/${store}`),
);
